export enum NotificationTypes {
    Info = 1,
    Success = 2,
    Warning = 3,
    Error = 4,
    System
}